export default "__VITE_ASSET__BFvsTrPK__"